import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-default-layout',
    templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
